import React from "react";

const AdminConfirmModal = ({
    open,
    title,
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    danger = false,
    loading = false,
    onConfirm,
    onCancel
}) => {

    if (!open) return null;

    return (
        <div
            onMouseDown={onCancel}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.55)",
                backdropFilter: "blur(4px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                zIndex: 99999
            }}
        >
            <div
                onMouseDown={(e) => e.stopPropagation()}
                style={{
                    width: "100%",
                    maxWidth: "430px",
                    background: "#fff",
                    borderRadius: "22px",
                    padding: "28px",
                    boxShadow:
                        "0 25px 70px rgba(0,0,0,0.25)"
                }}
            >

                <h2
                    style={{
                        margin: "0 0 12px",
                        fontSize: "23px"
                    }}
                >
                    {title}
                </h2>

                <p
                    style={{
                        margin: 0,
                        color: "#64748b",
                        lineHeight: 1.6
                    }}
                >
                    {message}
                </p>


                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "12px",
                        marginTop: "26px"
                    }}
                >

                    <button
                        type="button"
                        disabled={loading}
                        onClick={onCancel}
                        style={{
                            padding: "11px 18px",
                            borderRadius: "10px",
                            border: "1px solid #d1d5db",
                            background: "#fff",
                            cursor: "pointer",
                            fontWeight: "700"
                        }}
                    >
                        {cancelText}
                    </button>


                    <button
                        type="button"
                        disabled={loading}
                        onClick={onConfirm}
                        style={{
                            padding: "11px 18px",
                            borderRadius: "10px",
                            border: "none",
                            background:
                                danger
                                    ? "#ef4444"
                                    : "#ff5f91",
                            color: "#fff",
                            cursor:
                                loading
                                    ? "not-allowed"
                                    : "pointer",
                            fontWeight: "700",
                            opacity:
                                loading
                                    ? 0.7
                                    : 1
                        }}
                    >
                        {loading
                            ? "Please wait..."
                            : confirmText}
                    </button>

                </div>

            </div>
        </div>
    );
};

export default AdminConfirmModal;